module.exports = __webpack_public_path__ + "img/guanwang.ce087f64.png";